import { Modal, Stack } from '@fluentui/react';
import { Signing } from 'ap/signing';
import { AccountingEntryView } from 'ap/signing/accountingEntry/view';
import { TransactionSigningView } from 'ap/signing/transactionSigning/view';
import { CloseButton } from 'common/components/Buttons';
import { LISTVIEW_MODAL_HEIGHT, LISTVIEW_MODAL_WIDTH } from 'common/constants';
import { useState } from 'react';

export interface InvoiceListViewType {
  setinvoiceListVisible: React.Dispatch<React.SetStateAction<boolean>>;
  filterSupplierId: string | undefined;
}

export const InvoiceListView: React.FC<InvoiceListViewType> = ({
  setinvoiceListVisible,
  filterSupplierId,
}) => {
  const [transactionId, setTransactionId] = useState<string | undefined>(
    undefined
  );
  const [isAccountingEntry, setIsAccountingEntry] = useState<boolean>(false);
  if (transactionId) {
    if (isAccountingEntry)
      return (
        <AccountingEntryView
          itemId={transactionId}
          setTransactionId={setTransactionId}
        />
      );
    return (
      <TransactionSigningView
        itemId={transactionId}
        setTransactionId={setTransactionId}
      />
    );
  }
  return (
    <Modal isOpen>
      <Stack
        tokens={{ childrenGap: 20 }}
        style={{
          height: LISTVIEW_MODAL_HEIGHT,
          width: LISTVIEW_MODAL_WIDTH,
        }}
      >
        <Signing
          filterSupplierId={filterSupplierId}
          setTransactionId={setTransactionId}
          setinvoiceListVisible={setinvoiceListVisible}
          setIsAccountingEntry={setIsAccountingEntry}
        />
      </Stack>
    </Modal>
  );
};
